<template>
	<div class="order-summary">
		<div class="summary-title border-bottom">Resumen de Compra</div>
		<div class="summary-body">
			<div class="summary-row">
				<div class="summary-col bold">Subtotal</div>
				<div class="summary-col right">{{ currencySymbol }} {{ amount }}</div>
			</div>
			<div class="summary-row">
				<div class="summary-col">Envío</div>
				<div class="summary-col right">{{ currencySymbol }} {{ shippingPrice }}</div>
			</div>
			<div class="summary-row border-top">
				<div class="summary-col summary-total">Total</div>
				<div class="summary-col red-bold" :style="`color:${globalColors.primary}`">{{ currencySymbol }} {{ total }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'order-summary',
		props: {
			amount: [Number, String],
			currencySymbol: String,
			shippingPrice: [Number, String],
			total: [Number, String],
		},
	};
</script>

<style lang="scss" scoped>
	.order-summary {
		background-color: color(grayMedium);
		border: 1px solid color(borderThum);
		border-radius: 11px;
		max-width: 294px;
		min-height: 185px;
		padding: 15px 40px;
		width: 100%;
	}

	.summary {
		&-row {
			align-items: center;
			display: flex;
			justify-content: center;

			&:first-child {
				padding-bottom: 10px;
			}
		}

		&-col {
			color: color(spaceLight);
			font-size: size(medium);
			width: 50%;

			&.bold {
				font-family: font(avenirDemi);
			}

			&.right {
				text-align: right;
			}
		}

		&-title {
			font-family: font(avenirBold);
			font-size: size(normal);
			padding-bottom: 15px;
			text-align: center;
		}

		&-total {
			font-family: font(avenirBold);
			font-size: size(medium);
			text-align: left;
			text-transform: uppercase;
		}
	}

	.border {
		&-bottom {
			border-bottom: 1px solid color(borderThum);
			margin-bottom: 12px;
		}

		&-top {
			border-top: 1px solid color(borderThum);
			margin-top: 10px;
			padding: 8px 0px;
		}
	}

	.red-bold {
		font-family: font(open-bold);
		font-size: size(normal);
		text-align: right;
	}
</style>


// WEBPACK FOOTER //
// order-summary.vue?88941472